import React, { Component } from 'react';

import { connect } from 'react-redux';

import _ from 'underscore';
import { routeActions } from 'react-router-redux';

import { bindActionCreators } from 'redux';


import * as authActions from 'redux/modules/auth';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(state => ({
  user: state.auth.user,
  //error:state.products.error 
}),
  dispatch => bindActionCreators({ ...authActions, ...routeActions }, dispatch))


export default class Demo extends Component {

  componentDidMount() {

    this.props.login({ username: 'demo', password: 'demo' }).then(() => {
      this.props.push('/home');
    });
  }

  render() {
    return (
      <div />
    );
  }
}



